import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { anchoredStyles } from './Anchored.styles';
import { Base } from '../Base';
import { useStyles } from '../../hooks/useStyles';
export const Anchored = forwardRef(function Anchored(props, forwardedRef) {
    const { styles, sx, horizontalOrigin = 'right', verticalOrigin = 'top', overlap = 'rectangular', children, content, invisible: invisibleProp, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'Anchored',
        styles: [anchoredStyles, styles],
    });
    const invisible = invisibleProp || !content;
    return (_jsxs(Base, { ...other, sx: [globalStyles, combineStyles('host'), sx], ref: forwardedRef, children: [children, _jsx("div", { ...getStyles('content', `content$${overlap}$${verticalOrigin}$${horizontalOrigin}`, invisible &&
                    `content$${overlap}$${verticalOrigin}$${horizontalOrigin}$invisible`), children: content })] }));
});
